import {
  FilterMode,
  SatelliteTask_OrderBy,
  SatelliteTask,
  SortOrder,
  SatelliteTask_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const satelliteTaskService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.satelliteTaskOne({ id });
    return result.satelliteTaskOne as SatelliteTask;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: SatelliteTask_OrderBy[] | null = null,
    filter: SatelliteTask_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: SatelliteTask_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { taskType: { contains: searchValue, mode: FilterMode.Insensitive } },
          {
            correlationId: {
              contains: searchValue,
              mode: FilterMode.Insensitive,
            },
          },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.satelliteTaskListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ taskType: SortOrder.Asc }, { correlationId: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.satelliteTaskListWithOffset
    ) as SatelliteTask[];
    return { list, orderBy };
  },
};
